import { useEffect, useRef, useState } from 'react';
import { toAbsoluteUrl, FiltersToFormData, getAccessToken } from '@/utils';
import { createDataTableOptions, createDataTableConfig } from '@/utils';
import { toast } from 'sonner';
import { KeenIcon } from '@/components';
import { CustomFieldModal } from './CustomFieldModal';
import customFieldService from '@/services/setting/customFieldService'
import { UserProfileHero } from '@/partials/heros';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { ConfirmationModal } from '@/components/modal';
import { useConfirmationModal } from '@/hooks';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import 'datatables.net-select-dt';
import 'datatables.net-responsive-dt';
import { createRoot } from 'react-dom/client';
import { SelectInput, TYPE_OPTIONS, FIELD_TYPE_OPTIONS, YES_NO_NUMBER_OPTIONS, FilterContainer, ColumnToggleDropdown } from '@/components/TableFilter'
import { cn } from '@/lib/utils';
import Loader from '@/components/ui/Loader'
import { useAuthContext } from '@/auth';
import { goToLogin, goTo403 } from "@/utils/Navigation";
import { Container } from '@/components/container';

DataTable.use(DT);
const CustomFields = () => {
  const { logout } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState('create');
  const [selectedData, setSelectedData] = useState(null);
  const [dataLoading, setDataLoading] = useState(false)
  const [customFieldData, setCustomFieldData] = useState([]);
  const [itemId, setItemId] = useState(null);
  const { isOpen, actionId, openModal, closeModal } = useConfirmationModal();
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState({
    type: null,
    field_type: null,
    is_show: null,
    is_required: null,
  });
  const API_URL = import.meta.env.VITE_APP_BASE_URL;
  const token = getAccessToken();
  const tableRef = useRef(null);
  const filterRef = useRef(filterData);
  const formikRef = useRef();

  const badgeClasses = {
    contact: 'badge-primary',
    user: 'badge-info',
    matter: 'badge-warning',
  };

  useEffect(() => {
    filterRef.current = filterData;
  }, [filterData]);

  const columns = [
    // {
    //   title: 'S#',
    //   name: 'serial',
    //   data: null,
    //orderable: true,se,
    //   render: (data, type, row, meta) => meta.row + 1,
    // },
    {
      data: 'type',
      title: 'Type',
      name: 'type',
      orderable: true,
      render: function (value) {
        return `<span class="capitalize badge badge-pill badge-outline gap-1 items-center ${badgeClasses[value]}">
        <span class="badge badge-dot size-1.5 ${badgeClasses[value]}"></span>
        ${value}
      </span>`;
      }
    },
    { data: 'title', title: 'Title', name: 'title' },
    {
      data: 'placeholder',
      title: 'Placeholder',
      name: 'placeholder',
      render: function (value) {
        if (!value) return '-';
        return `<span class="capitalize">${value}</span>`;
      }
    },
    {
      data: 'field_type',
      title: 'Field Type',
      name: 'field_type',
      render: function (value) {
        return `<span class="capitalize">${value}</span>`;
      }
    },
    {
      data: 'is_required',
      title: 'Required',
      name: 'is_required',
      render: function (value) {
        const requiredVal = value ? 'Yes' : 'No';
        return `<span>${requiredVal}</span>`;
      }
    },

    // ---- Extended columns ----
    // {
    //   data: 'id',
    //   title: 'ID',
    //   name: 'id',
    //   visible: false,
    //   render: (data) => data ?? '-'
    // },
    {
      data: 'options',
      title: 'Options',
      name: 'options',
      render: (data) => {
        if (!data) return '-';
        if (Array.isArray(data)) return data.join(', ');
        return data;
      }
    },
    // {
    //   data: 'tooltip',
    //   title: 'Tooltip',
    //   name: 'tooltip',
    //   render: (data) => data ?? '-'
    // },
    {
      data: 'created_at',
      title: 'Created At',
      name: 'created_at',
      render: (data) => data ?? '-'
    },
    {
      data: 'updated_at',
      title: 'Updated At',
      name: 'updated_at',
      render: (data) => data ?? '-'
    },
    // {
    //   data: 'is_show',
    //   title: 'Always Visible',
    //   name: 'is_show',
    //   render: (value) => (value ? 'Yes' : 'No')
    // },
    {
      title: 'Actions',
      name: 'actions',
      data: null,
      orderable: false,
      searchable: false,
      render: (data, type, row) => `<div id="action-cell-${row.id}"></div>`,
    },
  ];


  const defaultVisibleColumns = [
    // 'serial',
    'type',
    'title',
    'placeholder',
    'field_type',
    'is_required',
    'created_at',
    'actions',
  ];

  const handleSubmit = async (formData) => {
    const isEdit = mode === 'edit';
    const action = isEdit ? customFieldService.updateCustomField : customFieldService.createCustomField;
    const args = isEdit ? [formData, itemId] : [formData];
    try {
      isEdit ? setLoading(true) : setIsLoading(true);
      const { data, status } = await action(...args);
      if (status) {
        setOpen(false);
        refresh();
        toast.success(`Custom Field ${isEdit ? 'Updated' : 'Created'} Successfully`, {
          description: `${data.title} field for ${data.type} ${isEdit ? 'updated' : 'created'} successfully.`,

        })
      }
    } catch (error) {
      console.error('Error', error)
      if (error.message == '422 Unprocessable Entity. Validation failed.') {
        const validationErrors = error.errors
        const formattedErrors = Object.fromEntries(
          Object.entries(validationErrors).map(([key, value]) => [key, value[0]])
        );

        formikRef.current?.setErrors(formattedErrors);
        toast.error('Validation Error.', {
          description: 'Please check your input. Some fields may be invalid.',

        });
        return
      } else {
        toast.error('Oops! Something went wrong.', {
          description: 'An error occurred while creating Custom Field. Please try again in a moment.',

        });
      }
    } finally {
      isEdit ? setLoading(false) : setIsLoading(false);
    }
  };

  const getAllCustomFields = async (userFilter = {}) => {
    setDataLoading(true);
    const filters = {
      ...userFilter,
      page: pageIndex + 1, // assuming your API is 1-based index
      page_size: pageSize,
    };
    try {
      const { data, status, recordsTotal } = await customFieldService.getAllCustomFields(filters);
      if (status) {
        setCustomFieldData(data)
        setTotalRecords(recordsTotal)
      }
    } catch (error) {
      console.error('Error', error)
      toast.error('Failed to fetch Custom Fields.', {
        description: 'An error occurred while fetching Custom Fields. Please try again later.',

      });
    } finally {
      setDataLoading(false)
    }
  }

  const handleDelete = async () => {
    closeModal();
    try {
      const { status } = await customFieldService.deleteCustomField(actionId);
      if (status) {
        refresh()
        toast.success('Deleted Custom Field.', {
          description: 'Custom field deleted Successfully.',

        });
      }
    } catch (error) {
      console.error('Error', error)
      if (error.message.includes('cannot be deleted')) {
        toast.error('Unable to delete Custom Field.', {
          description: error.message || `Can't delete: This Custom Field is in use and cannot be deleted.`,
        });
        return
      }
      toast.error('Failed to delete Custom Field.', {
        description: 'An error occurred while deleting Custom Field. Please try again later.',

      });
    }
  }

  const handleEditCustomField = async (id) => {
    setItemId(id)
    setOpen(true)
    setIsLoading(true)
    setMode('edit')
    try {
      const { data, status } = await customFieldService.getSingleCustomFields(id);
      if (status) {
        setSelectedData(data)
      }
    } catch (error) {
      console.error('Error', error)
      toast.error('Failed to fetch Custom Fields.', {
        description: 'An error occurred while fetching Custom Fields. Please try again later.',

      });
    } finally {
      setIsLoading(false)
    }
  }

  const handleModalClose = () => {
    setItemId(null)
    setSelectedData(null)
    setMode('create')
    setOpen(false)
  }

  const renderCustomActions = (row) => {
    const { id, status } = row;
    const isActive = status === 'active';

    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" className="text-gray-600">
            <KeenIcon icon="dots-vertical" className="text-[18px]" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-40">
          <DropdownMenuItem onClick={() => handleEditCustomField(id)}>
            <KeenIcon icon="notepad-edit" className="mr-0.5 h-4 w-4 cursor-pointer" /> Edit
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => openModal(id)} className="text-red-600 cusror-pointer">
            <KeenIcon icon="trash" className="mr-0.5 h-4 w-4" /> Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    );
  };

  const ajaxConfig = createDataTableConfig('/settings/custom-fields/data_table_list', filterRef, token, logout);

  const options = createDataTableOptions({
    order: [[6, 'desc']],
    initComplete: function () {
      const api = this.api();
      api.columns().every(function () {
        const col = this;
        const name = col.settings()[0].aoColumns[col.index()].name;
        if (name && !defaultVisibleColumns.includes(name)) {
          col.visible(false);
        }
      });
    },
    drawCallback: function () {
      const api = this.api();
      const rows = api.rows({ page: 'current' }).data();

      rows.each((row) => {
        const container = document.getElementById(`action-cell-${row.id}`);
        if (container) {
          if (!container._reactRoot) {
            container._reactRoot = createRoot(container);
          }
          container._reactRoot.render(renderCustomActions(row));
        }
      });
    },
  });

  const refresh = () => {
    const table = tableRef.current.dt();
    table.ajax.reload();
  };

  const resetFilters = () => {
    const cleared = {
      type: null,
      field_type: null,
      is_show: null,
      is_required: null,
    };

    setFilterData(cleared);
    filterRef.current = cleared;
    refresh()
  };

  const handleFilterChange = (key, val) => {
    setFilterData((prev) => {
      const updated = { ...prev, [key]: val };
      filterRef.current = updated;
      //console.log('updated',updated)
      return updated;
    });
  };

  const handleToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  return (
    <>
      <Container>
        <FilterContainer
          show={showFilter}
          onApply={() => refresh()}
          onReset={resetFilters}
        >
          <SelectInput
            label="Type"
            value={filterData.type}
            onChange={(val) => handleFilterChange('type', val)}
            staticOptions={TYPE_OPTIONS}
            customclassName="sm:w-[32%] w-full"
          />

          <SelectInput
            label="Field Type"
            value={filterData.field_type}
            onChange={(val) => handleFilterChange('field_type', val)}
            staticOptions={FIELD_TYPE_OPTIONS}
            customclassName="sm:w-[32%] w-full"
          />

          <SelectInput
            label="Required"
            value={filterData.is_required}
            onChange={(val) => handleFilterChange('is_required', val)}
            staticOptions={YES_NO_NUMBER_OPTIONS}
            customclassName="sm:w-[32%] w-full"
          />

          {/* <SelectInput
            label="Always Visible"
            value={filterData.is_show}
            onChange={(val) => handleFilterChange('is_show', val)}
            staticOptions={YES_NO_NUMBER_OPTIONS}
            customclassNamesm:w-[32%] w-full"
          /> */}
        </FilterContainer>

        <div className="min-w-full mb-4 card">
          <div className="card-header">
            <div className='flex items-center gap-1'>
              <ColumnToggleDropdown tableRef={tableRef} columns={columns} defaultVisibleColumns={defaultVisibleColumns} />
              {/* <h3 className="card-title">Custom Fields</h3> */}
            </div>

            <div className='flex flex-wrap items-center gap-2'>
              <button className='text-xs btn btn-sm btn-primary btn-outline' onClick={handleToggleFilter}>
                <KeenIcon icon="filter" className="w-fit btn-icon" />
                {showFilter ? 'Hide Advanced Filters' : 'Advanced Filters'}
              </button>
              <button className='text-xs btn btn-sm btn-light' onClick={() => { setOpen(true) }}>
                <KeenIcon icon="plus" className="w-fit btn-icon" />
                Add New
              </button>
            </div>

          </div>

          <DataTable
            id="contact-table"
            ajax={ajaxConfig}
            columns={columns}
            options={options}
            ref={tableRef}
          />
        </div>

        <CustomFieldModal
          open={open}
          onClose={handleModalClose}
          mode={mode}
          data={selectedData}
          onSubmit={handleSubmit}
          createFieldLoading={isLoading}
          updateFieldLoading={loading}
          ref={formikRef}
        />

        <ConfirmationModal
          show={isOpen}
          onClose={closeModal}
          onConfirm={handleDelete}
          message="Are you sure you want to delete this Custom Field? This action is permanent and cannot be undone."
          title="Are You Sure?"
        />
      </Container>
    </>
  );
};
export { CustomFields };
